module.exports = __webpack_public_path__ + "static/media/IMG_2531.ddf7dfaf.JPG";